// extracted by mini-css-extract-plugin
export default {"closeForm":"closeform_closeForm__8ktqM"};